export default __webpack_public_path__ + "static/media/download (4).321f2e5d.jpg";